import { defineStore } from 'pinia';
import { useListSites, type SiteResponse } from '../api/listSites';
import { ref } from 'vue';
import { useActionFailedAlert } from 'shared/problems/composables/actionFailedAlert';

export const useSiteStore = defineStore('sites', () => {
  const sites = ref<SiteResponse[]>([]);
  const initialized = ref(false);
  const initializing = ref(false);
  const listSites = useListSites();
  const actionFailedAlert = useActionFailedAlert();

  return {
    initialize,
    add,
    remove,
    getById,
    getSites,
    sites,
    initializing,
  };

  function getById(id: number) {
    return sites.value.find((v) => v.id === id);
  }

  async function initialize() {
    if (initialized.value || initializing.value) return;
    try {
      initializing.value = true;

      const response = await listSites.execute();

      if (!response.ok) {
        actionFailedAlert.show(response.details);
        return;
      }

      sites.value = response.sites;
      initialized.value = true;
    } finally {
      initializing.value = false;
    }
  }

  function add(site: SiteResponse) {
    removeById(site.id);
    sites.value.push(site);
  }

  function remove(id: number) {
    removeById(id);
  }

  function removeById(id: number) {
    const index = sites.value.findIndex((v) => v.id === id);
    if (index > -1) {
      sites.value.splice(index, 1);
      return true;
    }

    return false;
  }

  function getSites() {
    return sites.value.sort((a, b) => a.name.localeCompare(b.name));
  }
});
